var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_385)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.876 6.375a3.67 3.67 0 00-2.323.826c-.423.347-.764.79-.988 1.28a.73.73 0 00.345.957.71.71 0 00.947-.352c.133-.291.337-.554.59-.762a2.265 2.265 0 011.429-.505c1.214 0 2.2.948 2.2 2.112 0 1.093-.853 1.997-1.987 2.101-.071.007-.142.01-.213.01H11.827a.72.72 0 00-.674.722v1.889c0 .398.32.722.712.722a.717.717 0 00.71-.722V13.41c1.708-.323 2.925-1.754 2.925-3.479 0-1.961-1.626-3.556-3.624-3.556z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.876 6.375a3.67 3.67 0 00-2.323.826c-.423.347-.764.79-.988 1.28a.73.73 0 00.345.957.71.71 0 00.947-.352c.133-.291.337-.554.59-.762a2.265 2.265 0 011.429-.505c1.214 0 2.2.948 2.2 2.112 0 1.093-.853 1.997-1.987 2.101-.071.007-.142.01-.213.01H11.827a.72.72 0 00-.674.722v1.889c0 .398.32.722.712.722a.717.717 0 00.71-.722V13.41c1.708-.323 2.925-1.754 2.925-3.479 0-1.961-1.626-3.556-3.624-3.556",
    stroke: "currentColor",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.854 16.875a.75.75 0 000 1.5.75.75 0 000-1.5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.854 16.875a.75.75 0 000 1.5.75.75 0 000-1.5",
    stroke: "currentColor",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_385"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgHelp.displayName = 'Help';
export default SvgHelp;